import { getComboBoxControlWidthOffset } from '@1js/acui-combobox';

import { RibbonControlProps } from '.';

/**
 * For QuickScaling, it's necessary to determine the width of a specific component. Some controls have special properties that distort
 * their component's width. This function identifies those special cases and returns the necessary offset
 *
 * @param controlProps The properties of the given control
 * @param adjacentControlProps The properties of the control directly adjacent to the given control
 * @returns The number of pixels (offset) required to accurately measure the effect of removing the given control
 */
export function getOffsetForSpecificControlType(
  controlProps?: RibbonControlProps,
  adjacentControlProps?: RibbonControlProps
) {
  switch (controlProps?.type) {
    case 'AppComboBoxProps': {
      return getComboBoxControlWidthOffset(
        controlProps,
        adjacentControlProps?.type === 'AppComboBoxProps' ? adjacentControlProps : undefined
      );
    }
  }
  return 0;
}
